import { Autocomplete, Box, Button, Dialog, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { DateField, LocalizationProvider, frFR } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { COLORS, toEuro } from "../settings/themeSettings";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";





const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: '1000px',
        width: '1000px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}





function AddPaymentDialog(props) {
    const { onClose, open, isComptant, initialData, isEditMode } = props;
    const paymentMethods = isComptant 
        ? ['Chéque', 'CASH', 'carte de crédit', 'Autre']
        : ['compte', 'Chéque', 'CASH', 'carte de crédit', 'Autre'];

    const [modePaiement, setModePaiement] = useState(isComptant ? 'CASH' : (paymentMethods[0] || ''));
    const [montant, setMontant] = useState('');
    const [date, setDate] = useState(dayjs(new Date()));
    const [commentaire, setCommentaire] = useState('');
    const [autre, setAutre] = useState('');


    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        onClose();
    };


    const addPayment = () => {
        const payment = {
            methode: (modePaiement === 'Autre') ? autre : modePaiement,
            montant,
            date: date ? date.toISOString().split('T')[0] : null,
            commentaire
        }

        onClose(payment);
    }

    useEffect(() => {
        if (open) {
            if (initialData && isEditMode) {
                setModePaiement(initialData.methode || (isComptant ? 'CASH' : 'compte'));
                setMontant(initialData.montant || '');
                setDate(initialData.date ? dayjs(initialData.date) : dayjs(new Date()));
                setCommentaire(initialData.commentaire || '');
                if (!paymentMethods.includes(initialData.methode)) {
                     setAutre(initialData.methode);
                }
            } else {
                setModePaiement(isComptant ? 'CASH' : 'compte');
                setCommentaire('');
                setDate(dayjs(new Date()));
                setMontant('');
                setAutre('');
            }
        }
    }, [open, isComptant, initialData, isEditMode]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}>
            <Dialog onClose={handleClose} open={open} maxWidth={'lg'} PaperProps={{ sx: { minWidth: '700px' } }} >
                <DialogTitle
                    sx={{
                        backgroundColor: COLORS.secondary,
                        color: 'white',
                        mb: 5
                    }}
                >{isEditMode ? "Modifier le paiement" : "Ajouter un paiement"}</DialogTitle>


                <Stack
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: '400px',
                        padding: '10px 0'

                    }}

                >

                    <Box
                        width={'300px'}
                    >
                        <Typography
                            variant="p"
                            sx={styles.pathtitle}

                        >
                            Mode de paiement
                        </Typography>
                        <Autocomplete
                            value={modePaiement || null}
                            onChange={(event, newValue) => {
                                setModePaiement(newValue || '');
                            }}
                            inputValue={modePaiement || ''}
                            onInputChange={(event, newInputValue) => {
                                setModePaiement(newInputValue);
                            }}
                            options={paymentMethods}
                            sx={{ width: 300, mt: '15px' }}

                            color="secondary"
                            renderInput={(params) => <TextField {...params} label="Paiement" />}
                            clearIcon={false}

                        />

                        {
                            (modePaiement === "Autre") && (
                                <TextField

                                    margin="normal"
                                    required
                                    fullWidth
                                    name="autre"
                                    label="Précisez le mode de paiment"
                                    InputProps={{ style: { height: '45px' } }}
                                    color="secondary"
                                    focused
                                    placeholder='mode de paiement'
                                    value={autre}
                                    onChange={(e) => setAutre(e.target.value)}

                                />

                            )
                        }

                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Montant"
                            label="Montant"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            focused
                            placeholder='Montant en CFA'
                            type='number'
                            value={montant}
                            onChange={(e) => setMontant(e.target.value)}
                        />

                        <TextField

                            margin="normal"
                            fullWidth
                            name="Montant en EURO"
                            label="Montant En EURO"
                            InputProps={{ style: { height: '45px' } }}
                            color="secondary"
                            placeholder='Montant en Euro'
                            value={toEuro(montant)}
                            disabled
                        />


                        <DateField
                            label="Date du paiement"
                            color="secondary"
                            focused
                            fullWidth
                            sx={{ mt: 2.5 }}
                            InputProps={{ style: { height: '45px' } }}
                            onChange={(e) => setDate(e)}
                            format="DD-MM-YYYY"
                            value={date}


                        />


                        <TextField

                            margin="normal"
                            required
                            fullWidth
                            name="Commentaire"
                            label="Commentaire"
                            InputProps={{ style: { height: '100px' } }}
                            color="secondary"
                            focused
                            multiline={true}
                            onChange={(e) => setCommentaire(e.target.value)}
                        />



                    </Box>
                </Stack>
                <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 4, pb: 5, pr: 2 }}>
                    <Button variant="outlined" color="error" onClick={handleClose}>Annuler</Button>
                    <Button variant="contained" color="secondary" onClick={addPayment}>{isEditMode ? "Enregistrer" : "Valider"}</Button>
                </Stack>

            </Dialog>

        </LocalizationProvider>
    );
}


export default AddPaymentDialog;
